import React from 'react'
import "./index.css";
import { AboutHero } from './AboutHero';
import { WhoWe } from './WhoWe';
import { WhatMakes } from './WhatMakes';
import { OurValues } from './OurValues';
import { OurAchievements } from './OurAchievements';
import { WhatOurClients } from '../Home/WhatOurClients';
import { StartYourProject } from '../Home/StartYourProject';

export const About = () => {
  return (
    <div className='aboutContainer'>
        <AboutHero/>
        <WhoWe/>
        <WhatMakes/>
        <OurValues/>
        <OurAchievements/>
        <WhatOurClients/>
        <StartYourProject/>
    </div>
  )
}
